import { removeAccessTokens } from '@cma/features/auth'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function Logout() {
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect') || ''

  useEffect(() => {
    removeAccessTokens()
    window.open(
      `${process.env.VITE_APP_CMA_URL}${
        redirect.startsWith('/') ? redirect : '/'
      }`,
      '_self'
    )
  }, [redirect])

  return null
}
